import { Checkbox, Fab, ListItemText, makeStyles, MenuItem, TextField } from '@material-ui/core';
import React, { useMemo, useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import FilterIcon from '@material-ui/icons/FilterList';
import { useRecentGetter } from '@lib/common';
import { $in } from '../operators';
import { startCase } from 'lodash';
import Observable, { Observer } from 'rxjs';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
type EnumObject = { label: any; value: any };
type EnumMap = EnumObject[];
const useStyles = makeStyles({
  root: {
    width: '300px',
  },
  center: {
    textAlign: 'center',
  },
});

export function withMultiSelectFromApi<T>(
  enumMap: any,
  captitalizeOptions: boolean = false,
  dataObservable: any,
  requiredMaster: string
  //   requiredParams:any
) {
  return function filtersMultiSelectFromApi(props) {
    const [masterData, setMasterData] = useState([]);
    const [reverseMasterData, setReverseMasterData] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      const subscription = dataObservable().subscribe({
        next: data => {
          const requiredMasterData = data[requiredMaster];
          setMasterData(requiredMasterData);
          const tempMasterData = {};
          requiredMasterData.forEach(x => (tempMasterData[x['id']] = x['name']));
          setReverseMasterData(tempMasterData);
          setLoading(false);
        },
        error: err => {
          setLoading(false);
           console.error(err);
        },
      });
      return () => subscription.unsubscribe();
    }, []);
    const StringIsNotNumber = value => isNaN(Number(value)) === true;
    const classes = useStyles();
    const { handleSubmit, ...form } = useForm();
    const {
      column: { filterValue, setFilter },
      closeFilter,
    } = props;

    const getFilterValue = useRecentGetter(filterValue);
    const getFilterSetter = useRecentGetter(setFilter);
    const getCloseFilter = useRecentGetter(closeFilter);

    const submit = useMemo(
      () =>
        handleSubmit(values => {
          const toSet = {
            ...getFilterValue(),
          };
          if (values.value) {
            toSet[$in.key] = values.value.join(',');
            getFilterSetter()(toSet);
          }
          getCloseFilter()();
        }),
      []
    );

    return (
      <form onSubmit={submit}>
        <Controller
          control={form.control}
          name="value"
          defaultValue={[]}
          render={({ onChange, value }) => {
            return (
              <TextField
                classes={{ root: classes.root }}
                select
                id="Values"
                variant="outlined"
                label="Select one/multiple"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start" style={{ paddingRight: '10px' }}>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    </InputAdornment>
                  ),
                }}
                SelectProps={{
                  multiple: true,
                  value: value,
                  renderValue: selected =>
                    (selected as Array<string>)
                      .map(element =>
                        captitalizeOptions
                          ? (reverseMasterData[element] as string).toUpperCase()
                          : startCase(reverseMasterData[element])
                      )
                      .join(', '),
                  onChange: onChange,
                  MenuProps: {
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                  },
                }}>
                {!!masterData &&
                  masterData.map(v => {
                    return (
                      <MenuItem key={v.id} value={v.id}>
                        <Checkbox checked={value.includes(v.id)} />
                        <ListItemText
                          primary={
                            captitalizeOptions
                              ? (v.name as string).toUpperCase()
                              : startCase(v.name as string)
                          }
                        />
                      </MenuItem>
                    );
                  })}
              </TextField>
            );
          }}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Fab color="primary" size="small" type="submit">
          <FilterIcon />
        </Fab>
      </form>
    );
  };
}
